import { useTranslations } from 'next-intl';
import { ComparisonGroup, RowValue } from './comparisonTypes';
import styles from './MobileComparison.module.css';

interface MobileComparisonProps {
  className?: string;
  data: ComparisonGroup[];
}

const CellValue = ({ value }: { value: RowValue }) => {
  const t = useTranslations('ring-pro');
  switch (value.type) {
    case 'text':
      return <span className={styles.cellText}>{value.value}</span>;
    case 'check':
      return (
        <span className={`${styles.cellIcon} ${styles.cellIconCheck}`} aria-label={t('ring-pro.comparison.aria.yes')}>
          ✓
        </span>
      );
    case 'cross':
      return (
        <span className={`${styles.cellIcon} ${styles.cellIconCross}`} aria-label={t('ring-pro.comparison.aria.no')}>
          ✗
        </span>
      );
    default:
      return null;
  }
};

export const MobileComparison = ({ className, data }: MobileComparisonProps) => {
  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      {data.map((group, groupIdx) => (
        <div className={styles.group} key={groupIdx}>
          {group.columnHeaders && (
            <>
              {group.heading && <div className={styles.groupSectionTitle}>{group.heading}</div>}
              <div className={styles.groupColumnHeader}>
                <div className={`${styles.groupColumnHeaderCol} ${styles.groupColumnHeaderColPro}`}>
                  {group.columnHeaders.proLabel}
                </div>
                <div className={styles.groupColumnHeaderCol}>
                  {group.columnHeaders.airLabel}
                </div>
              </div>
            </>
          )}
          <div className={styles.groupRows}>
            {group.rows.map((row, rowIdx) => (
              <div className={rowIdx === 0 && groupIdx === 0 ? `${styles.row} ${styles.rowIntro}` : styles.row} key={rowIdx}>
                {row.label && <div className={styles.rowLabel}>{row.label}</div>}
                <div className={styles.rowValues}>
                  <div className={`${styles.rowValue} ${styles.rowValuePro}`}>
                    <CellValue value={row.ringPro} />
                  </div>
                  <div className={styles.rowValue}>
                    <CellValue value={row.ringAir} />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {groupIdx < data.length - 1 && <div className={styles.divider} />}
        </div>
      ))}
    </div>
  );
};
